import { Box, Card } from "@mui/material";
import React, { useEffect } from "react";
import UserListData from "../components/FormBuilder/subcomponents/UserListData";
import { getAllUserList } from "../redux/entities/formBuilderEntity";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import Navbar from "../components/Navbar";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const UserListPage = () => {
  const listData = useAppSelector(
    (state) => state.entities.formBuilder.getAllUserList
  );
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  async function changeUserStatus(userId, status) {
    try {
      Swal.fire({
        text: `Are you sure, You want to mark user as ${status}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#5149E4",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        reverseButtons: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const token = localStorage.getItem("userToken");
            const response = await axios.post(`${API_BASE_URL}/user/change-user-status`, { userId }, { headers: { Authorization: `Bearer ${token}` } });
            if (response.data.status === "SUCCESS") {
              Swal.fire({ text: response?.data?.message, icon: "success" })
              await dispatch(getAllUserList());
            } else if (response?.data?.status === "JWT_INVALID") {
              Swal.fire({ text: response?.data?.message, icon: "warning" })
              navigate("/");
            } else {
              Swal.fire({ text: response?.data?.message, icon: "warning" })
            }
          } catch (error) {
            Swal.fire({ text: error?.message, icon: "warning", })
          }

        }
      });
    } catch (error) {
      Swal.fire({ text: error?.message, icon: "warning", })
    }
  }

  useEffect(() => {
    dispatch(getAllUserList());
  }, [dispatch]);

  return (
    <>
      <Navbar />
      {listData?.totalPages > 0 ? (
        <div className="d-flex mt-2 flex-column align-items-center justify-content-center">
          <h3>User Management</h3>
          <div className="form-templates row mt-1"></div>
          <Box sx={{ width: "100%" }}>
            <Card sx={{ p: 2 }}>
              <UserListData data={listData} changeUserStatus={changeUserStatus} />
            </Card>
          </Box>
        </div>
      ) : (
        <h3 className="d-flex mt-5 flex-column align-items-center justify-content-center">
          User Not Found
        </h3>
      )}
    </>
  );
};

export default UserListPage;
